import * as React from 'react';
import { FC, ReactNode } from 'react';
import classNames from 'classnames';
import styles from './assets/infoItem.module.scss';
import Router from '../navigation/router';
import { routes } from '../navigation';

interface Props {
    value: ReactNode | string;
    title: string;
    linkHref: string;
    linkTitle: string;
}

const InfoCaseRateItem: FC<Props> = ({ value, title, linkTitle, linkHref }: Props) => {
    return (
        <div className={classNames(styles.infoItem)}>
            {title ? <b className={classNames(styles.titleItem)}>{title}</b> : null}
            <span className={classNames(styles.titleItemText)}>
                case {linkTitle}: {value}
            </span>
        </div>
    );
};

export default InfoCaseRateItem;
